import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rti-details',
  templateUrl: './rti-details.component.html',
  styleUrls: ['./rti-details.component.scss']
})
export class RtiDetailsComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
